import {
    PrescriptionDocument,
    PrescriptionDocumentDataFormattedVoies,
    PrescriptionDocumentExternal,
    PrescriptionDocumentFormatted,
    PrescriptionDocumentLetter,
    PrescriptionDocumentText,
    UserHealthSystemInfo,
} from './graphql'

export * from './insi'
export * from './ordoclic'
export * from './routes/user'
export * from './routes/mail'
export * from './errors'

export type SeverityType = 'info' | 'warning' | 'error' | 'success'

export type ParamlessVoidFunction = () => void
export type ArrayElement<A> = A extends readonly (infer T)[] ? T : never

/**
 * TTD Medical Act Type
 * Used to share and split logic in components based on the medical act type.
 */
export type ActType = 'CONSULTATION' | 'TRANSMISSION'

/**
 * @description
 * All different PrescriptionDocument
 */
export type PrescriptionDocumentTypes =
    | PrescriptionDocument
    | PrescriptionDocumentText
    | PrescriptionDocumentFormatted
    | PrescriptionDocumentExternal
    | PrescriptionDocumentLetter

export type StripeStatus = 'COMPLETE' | 'INCOMPLETE' | 'NOT_CREATED'
export type PaymentStatus = 'NEW' | 'PAID'
export type PaymentProvider = 'STRIPE'

export interface UnavailabilityPeriod {
    from: string
    to: string
}

export type LabelAndValue<T> = { label: string; value: T }

export type MmdSearchResult = {
    cip?: string
    codeUnitePrise?: string
    label_form?: string
    listVoies?: PrescriptionDocumentDataFormattedVoies[]
    monoUrl?: string
    textKey?: string
    shortname?: string
    labelType: string
}

/** *********** USERS ****************** */

export type UserRpps = {
    __typename: 'UserRpps'
    identifiantpp: string | number
    codecivilitedexercice: string | undefined
    nomdexercice: string
    prenomdexercice: string
    libellesavoirfaire: string | undefined
    codecivilite: string | undefined
    codeprofession: string | number
    codesavoirfaire: string
    coderole: string | number
    libellerole: string
    firstName: string
    lastName: string
    libellecivilite: string
    userIdnps: number
    libelleprofession: string
    libellecommunecoordstructure: string
}

export type PointerObj = {
    __type: string
    className: string
    objectId: string
}

export type UserCategory = {
    label: string
    value: string
}

export type UserNotification = {
    email: boolean
    sms: boolean
}

export type UserStatus = {
    manager: boolean
    simple: boolean
}

export type emptyUserDataType = {
    objectId: string
    rppsNum: string
    rppsNumError: string
    amNum: string
    isEmployee: boolean
    employedSocName: string
    isSectorOne: boolean
    isOptam: boolean
    title: string
    civility: string
    prefix: string
    lastName: string
    firstName: string
    qualification: object
    profession: object
    speciality: object
    mentionsAndTitles: object[]
    privatePhone: string
    contactPhone: string
    email: string
    street: string
    postalCode: string
    city: string
    signature: string | null
    securedEmail: string
    availableSecuredEmails: string[]
    administrativeEmail: string[]
    bankName: string
    bic: string
    iban: string
    extraHealthSystemInfo: UserHealthSystemInfo | null
}

/* ******************** PHYSICIANS ***************** */
type ProfessionnalCategoriesLabel = 'Civil' | 'Etudiant' | 'Fonctionnaire' | 'Agent public'

export type AnnDataResponse = Partial<{
    identifiantpp: string
    codecivilitedexercice: string
    nomdexercice: string
    prenomdexercice: string
    libellesavoirfaire: string
    codeprofession: string
    codesavoirfaire: string
    libellecivilite: string
    codecivilite: string
    mssEmails: string[]
    userIdnps: string
    userRole: ProfessionnalCategoriesLabel[]
}>

export const UserRoleCodes = {
    SUPERUSER: 0,
    MANAGER: 1,
    SIMPLE: 2,
}

/** DENTAL */
export type DentalSchemaData = {
    teeth: Record<string, Tooth>
    chewingCoefficient: number
}
export type Tooth = {
    shortCode: ToothStateShortCode
    prosthesisShortCode: ProsthesisShortCode
    chewingCoefficient: ToothChewingCoefficient
}
export type ToothStateShortCode = 'X' | 'O' | 'C' | 'D' | 'R'
export type ProsthesisShortCode = 'PF' | 'PA' | '-'
export type ToothChewingCoefficient = 0 | 1 | 2 | 3 | 4 | 5

export type TTDFeatureFlag =
    | 'dmp'
    | 'infra_config'
    | 'minio'
    | 'pgssi_banners'
    | 'pgssi_update_email_or_phone'
    | 'regenerate_docs'
    | 'stripe'
    | 'visio_360'

export const ActiveFeatures: TTDFeatureFlag[] = [
    'dmp',
    'minio',
    'pgssi_banners',
    'pgssi_update_email_or_phone',
    'regenerate_docs',
    'stripe',
    'visio_360',
]
